@if (hhSeoDesc) {
<div>
  @if (hhSeoTitle) {
  <h2>{{hhSeoTitle}}</h2>
  }
  <div
    class="hh-desc content_from_mongo"
    id="content-text4"
    [innerHTML]="hhSeoDesc | safe: 'html'"
  ></div>
</div>
<div class="call_to_action_btn_box_desktop">
  <button (click)="openAuthDialog()" class="handyhand_button blue_button">
    {{ 'GENERAL.MEMBER' | translate }}
  </button>
</div>
}
